import { ReduxAction, UserSession } from '@app/types';
import { AppState } from '@reducers/rootReducer';

// should be moved to actions...
export const setUser = (payload: UserSession) => ({ type: 'SET_USER', payload });

export const selectUser = (state: AppState) => state.user.account;

export function userAccountReducer(
  state: Partial<UserSession> = {},
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'SET_USER':
      return {
        ...(payload || {}),
        isOverContactLimit: state.isOverContactLimit,
      };

    case 'FETCH_USER_CONTACT_COUNT_SUCCEEDED':
      const contactCount = payload?.response?.count || 0;
      // undefined means we don't have entitlement, null means unlimited
      const contactLimit = state?.contactLimit === undefined ? 0 : state.contactLimit;
      const isOverContactLimit =
        contactCount && contactLimit !== null && contactCount > contactLimit;

      return {
        ...state,
        isOverContactLimit,
      };

    default:
      return state;
  }
}

// Update desktop state in response to Redux store updates
export const syncUserStateToDesktopApp = (_store) => (next) => (action) => {
  if (action.type === 'SET_USER') {
    window.desktopIntegrations?.userUpdated?.(action.payload);
  }

  return next(action);
};
